import { ReactElement } from "react";
import { UseFormRegisterReturn } from "react-hook-form";

interface Props {
    label: string;
    icon?: ReactElement<any, any>;
    register: UseFormRegisterReturn<string>;
    type?: string;
}

export function InputDatosGenerales({ label, icon, register, type = "text" }: Props) {

    return (
        <div className="flex items-center gap-x-2 w-full mb-[11px]">
            <>
            {icon}
            </>
            <label className="font-semibold min-w-[150px]">{label}</label>

            <input 
                {...register}
                type={type}
                className="
                    rounded-[3px] border-gray-400 border my-1 px-2 
                    font-semibold text-gray-600 text-sm w-full"/>
        </div>
    );
}